(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/onboarding-info.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/onboarding-info.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$lbUti = svs.components.lbUtils.verify,
  verifyValue = _svs$components$lbUti.verifyValue,
  verifyObject = _svs$components$lbUti.verifyObject;
const _svs$templates$primar = svs.templates.primaryOnboarding.constants,
  hintVerifyType = _svs$templates$primar.hintVerifyType,
  TargetType = _svs$templates$primar.TargetType;
const _svs$templates$primar2 = svs.templates.primaryOnboarding.utils,
  findMap = _svs$templates$primar2.findMap,
  breakDownTarget = _svs$templates$primar2.breakDownTarget;
const removeTargetOfInteresetByKey = svs.templates.primaryOnboarding.target.removeTargetOfInteresetByKey;


const onboardingInfo = new Map();
const classNameToHints = new Map();
const idToHints = new Map();
const getHintFromKey = key => onboardingInfo.get(key);
const getHintsFromClassname = classname => {
  const keys = classNameToHints.get(classname);
  if (keys) {
    const hints = [];
    keys.forEach(key => {
      const hint = getHintFromKey(key);
      if (hint) {
        hints.push(hint);
      }
    });
    return hints;
  }
  return undefined;
};
const getHintsFromId = id => {
  const keys = idToHints.get(id);
  if (keys) {
    const hints = [];
    keys.forEach(key => {
      hints.push(getHintFromKey(key));
    });
    return hints.filter(v => v);
  }
  return undefined;
};
const getHintsFromTarget = target => {
  const _breakDownTarget = breakDownTarget(target),
    _breakDownTarget2 = _slicedToArray(_breakDownTarget, 2),
    targetType = _breakDownTarget2[0],
    targetClean = _breakDownTarget2[1];
  if (targetType === TargetType.Classname) {
    return getHintsFromClassname(targetClean);
  } else if (targetType === TargetType.Id) {
    return getHintsFromId(targetClean);
  }
  return undefined;
};
const classAndIdMapping = (target, key, classMapFn, idMapFn) => {
  const _breakDownTarget3 = breakDownTarget(target),
    _breakDownTarget4 = _slicedToArray(_breakDownTarget3, 2),
    targetType = _breakDownTarget4[0],
    targetClean = _breakDownTarget4[1];
  if (targetType === TargetType.Classname) {
    classMapFn(targetClean, key);
  } else if (targetType === TargetType.Id) {
    idMapFn(targetClean, key);
  }
};
const addTargetRef = (target, key) => {
  classAndIdMapping(target, key, (targetClean, key) => {
    const set = classNameToHints.get(targetClean);
    if (!set) {
      classNameToHints.set(targetClean, new Set([key]));
    } else {
      set.add(key);
    }
  }, (targetClean, key) => {
    const set = idToHints.get(targetClean);
    if (!set) {
      idToHints.set(targetClean, new Set([key]));
    } else {
      set.add(key);
    }
  });
};
const hasHintToId = id => idToHints.has(id) ? id : undefined;
const hasHintToClassName = classname => classNameToHints.has(classname) ? classname : undefined;
const removeIdOfInterest = id => {
  removeTargetOfInteresetByKey(idToHints.get(id));
};
const removeClassNameOfInterest = classname => {
  removeTargetOfInteresetByKey(classNameToHints.get(classname));
};
const removeTargetOfInterest = target => {
  const _breakDownTarget5 = breakDownTarget(target),
    _breakDownTarget6 = _slicedToArray(_breakDownTarget5, 2),
    targetType = _breakDownTarget6[0],
    targetClean = _breakDownTarget6[1];
  if (targetType === TargetType.Classname) {
    removeClassNameOfInterest(targetClean);
  } else if (targetType === TargetType.Id) {
    removeIdOfInterest(targetClean);
  }
};
const setOnboardingInfo = (key, value) => {
  verifyValue(key).isString();
  verifyObject(value).schema(hintVerifyType);
  onboardingInfo.set(key, value);
};
const forEachOnboardingInfo = fn => {
  onboardingInfo.forEach(fn);
};
const findOnboardingInfo = fn => findMap(onboardingInfo, fn);

setGlobal('svs.templates.primaryOnboarding.onboardingInfo', {
  getHintFromKey,
  getHintsFromClassname,
  getHintsFromId,
  getHintsFromTarget,
  addTargetRef,
  hasHintToId,
  hasHintToClassName,
  removeIdOfInterest,
  removeClassNameOfInterest,
  removeTargetOfInterest,
  setOnboardingInfo,
  forEachOnboardingInfo,
  findOnboardingInfo
});

 })(window);